import * as React from 'react';
import { CssBaseline } from '@mui/material';
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import Avatar from '@mui/material/Avatar';
import { useNavigate } from 'react-router-dom'; // 改为使用 useNavigate
import Fab from '@mui/material/Fab';
import EditIcon from '@mui/icons-material/Edit';
import { boxList, read } from './api'


// 将 BbInbox 组件修改为接受 messages 作为 prop
export default function BbInbox({ userId, anotherUserId }) {// 模拟从服务端获取数据

    const [messages, setMessages] = React.useState([]);
    const navigate = useNavigate();

    const getList = async () => {
        try {
            const result = await boxList({ userId });
            setMessages(result.dataList);
        } catch (err) {
            console.log("加载mail list出错:", err);
        }
    };

    React.useEffect(() => {
        getList();
    }, []); // 依赖 userId，当 userId 变化时重新请求数据

    return (
        <React.Fragment>
            <CssBaseline />
            <Paper square sx={{ pb: '50px', height: '100vh', overflow: 'hidden', }}>
                <List sx={{ mb: 2 }}>
                    {messages.map(({ orderId, id, sendUser, sendUserName, title, cover, createdTime }) => (
                        <React.Fragment key={id}>
                            {orderId === 1 && (
                                <ListSubheader sx={{ bgcolor: 'background.paper' }}>
                                    今天
                                </ListSubheader>
                            )}
                            {orderId === 2 && (
                                <ListSubheader sx={{ bgcolor: 'background.paper' }}>
                                    昨天
                                </ListSubheader>
                            )}
                            {orderId !== 2 && orderId !== 1 && (
                                <ListSubheader sx={{ bgcolor: 'background.paper' }}>
                                    {createdTime}
                                </ListSubheader>
                            )}
                            <ListItemButton onClick={() => {
                                read({ id });
                                navigate('/mailDetail', { state: { id } });
                                console.log("id: " + id); // 直接使用 id
                            }}>
                                <ListItemAvatar>
                                    <Avatar alt="Profile Picture" src={cover} />
                                </ListItemAvatar>
                                <ListItemText primary={sendUserName} secondary={title} />
                            </ListItemButton>
                        </React.Fragment>
                    ))}
                </List>
                <Fab color="secondary" aria-label="edit" sx={{ position: 'absolute', bottom: 100, right: 16 }}
                    onClick={() => {
                        const receivedUserId = anotherUserId; // 直接传递数字
                        navigate('/richTextEditor', { state: { userId, receivedUserId } });
                    }}
                >
                    <EditIcon />
                </Fab>
            </Paper>
        </React.Fragment >
    );
}